import React, { useState, useEffect, useContext } from 'react';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import Modal from 'react-bootstrap/Modal';
import BuscarEmpleado from '../BuscarEmpleado'
import { ContextGloball } from '../Context/ContextGlobal';
const server = process.env.REACT_APP_SERVER;

function ModuloAcceso() {
    const {loading,setLoading} = useContext(ContextGloball);
    const [modulos, setModulos] = useState([]);
    const [moduloSelec, setModuloSelec] = useState({});
    const [vista, setVista] = useState(0);
    const [empleadosModulo, setEmpleadosModulo] = useState([]);
    const [modalAddPermiso, setModalAddPermiso] = useState(false);
    const [selectEmpleado, setSelectEmpleado] = useState({});
    const [listaPermisos, setListaPermisos] = useState([]);
    const [idPermiso, setIdPermiso] = useState('');
    const [permisosUsuario, setPermisosUsuario] = useState([]);
    const [nuevoUsuario, setNuevoUsuario] = useState(false);
    const [addPermiso, setAddPermiso] = useState(-1);
    const [removePermiso, setRemovePermiso] = useState(-1);
    const [desabledAdd, setDesabledAdd] = useState(true);
    const [desabledRemove, setDesabledRemove] = useState(true);
    const [permisoSelect, setPermisoSelect] = useState({});
    const [regional, setRegional] = useState('');
    const [actualizar, setActualizar] = useState(false);
    const [modalAddColaborador, setModalAddColaborador] = useState(false);
    const [error, setError] = useState({});
    const agregarPermisoColaborador = () => {
        setSelectEmpleado({});
        setNuevoUsuario(true);
        setModalAddPermiso(true);
        setPermisoSelect({});
        setPermisosUsuario([]);
        setAddPermiso(-1);
        setRemovePermiso(-1);
        setDesabledAdd(true);
        setDesabledRemove(true);
        setError({})
    }
    const agregarPermiso = (colaborador) => {
        setNuevoUsuario(false);
        var info = colaborador.PERMISO.split(':');
        var dato = [];
        for (var pf = 0; pf < info.length; pf++) {
            dato.push(listaPermisos.filter((item) => item.ID_PERMISO == info[pf])[0])
        }
        setPermisosUsuario(dato);
        setSelectEmpleado(colaborador);
        setModalAddPermiso(true);
        setAddPermiso(-1);
        setRemovePermiso(-1);
        setDesabledAdd(true);
        setDesabledRemove(true);
    }
    const agregarPermisoAdd = (item) => {
        setPermisoSelect(item);
        setAddPermiso(item.ID_PERMISO);
        setDesabledAdd(false);
        setDesabledRemove(true);
        setRemovePermiso(-1);
    }
    const removePermisoRm = (item) => {
        setPermisoSelect(item);
        setRemovePermiso(item.ID_PERMISO);
        setDesabledRemove(false);
        setAddPermiso(-1);
        setDesabledAdd(true);
    }
    const addRmPermiso = (tipo) => {
        var admin = JSON.parse(localStorage.getItem("info")).ID_EMPLEADO;
        fetch(`${server}/moduloAcceso/addRemovePermiso`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, info: permisoSelect, user: selectEmpleado.ID_EMPLEADO,
                tipo, admin, modulo: moduloSelec.ID_MODULO
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    if (tipo === 'ADD') {
                        guardarAgregarPermiso()
                    } else {
                        guardarRemovePermiso()
                    }
                    setActualizar(!actualizar);
                }
            })
            .catch(err => console.log(err));
    }
    const guardarAgregarPermiso = () => {
        setListaPermisos(listaPermisos.filter((item) => item.ID_PERMISO !== permisoSelect.ID_PERMISO));
        setPermisosUsuario([...permisosUsuario, permisoSelect])
        setDesabledAdd(true);
    }
    const guardarRemovePermiso = () => {
        setPermisosUsuario(permisosUsuario.filter((item) => item.ID_PERMISO !== permisoSelect.ID_PERMISO))
        setDesabledRemove(true)
    }
    const salirBusqueda = () => {
        setModalAddColaborador(false);
        setModalAddPermiso(true);
    }
    const seleccionarColaborador = (clbr) => {
        var dato = empleadosModulo.filter((item) => item.ID_EMPLEADO === clbr.ID_EMPLEADO);
        if (dato.length === 0) {
            setError({});
            setSelectEmpleado(clbr);
        } else {
            setError({ "error": `Ya existe ${clbr.NOMBREX} en los permisos !!` })
        }
    }
    const entrarModulo = (dato) => {
        //var regional = JSON.parse(localStorage.getItem('__react_session__')).regional;
        setLoading(true);
        fetch(`${server}/moduloAcceso/getEmpleadosModulo`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional, info: dato
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setEmpleadosModulo(data.ok);
                    setModuloSelec(dato);
                    setListaPermisos(dato.permisos);
                    setVista(1);
                }
            })
            .catch(err => console.log(err));
    }
    function buscarColaborador() {
        var input, filter, table, tr, td, i, txtValue, div;
        input = document.getElementById("example-search-input");
        filter = input.value.toUpperCase();
        table = document.getElementById("tablaColaboradores");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[0];
            if (td) {
                txtValue = td.getElementsByTagName('div')[1].getElementsByTagName('div')[0].innerHTML;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    useEffect(() => {
        if (vista === 1) {
            entrarModulo(moduloSelec)
        }
    }, [actualizar])
    const obtenerListaModulos = (reg) => {
        fetch(`${server}/moduloAcceso/getModulos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: reg
            })
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false);
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    setModulos(data.ok);
                }
            })
            .catch(err => console.log(err));
    }
    function buscarPermisos() {
        var input, filter, cuadro, tr, td, i, txtValue;
        input = document.getElementById("buscarPermisoMo");
        filter = input.value.toUpperCase();
        cuadro = document.getElementById("listaPermisos");
        tr = cuadro.getElementsByTagName('button');
        for (i = 0; i < tr.length; i++) {
            txtValue = tr[i].innerHTML;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                tr[i].style.display = "";
            } else {
                tr[i].style.display = "none";
            }
        }
    }
    useEffect(() => {
        if (regional === '') {
            var region = JSON.parse(localStorage.getItem('__react_session__')).regional;
            setRegional(region);
            setLoading(true);
            obtenerListaModulos(region);
        } else {
            if (vista === 0) {
                setLoading(true);
                obtenerListaModulos(regional);
            }
        }
    }, [actualizar]);
    return (
        <div>
            {vista === 0 &&
                <div>
                    <div className='container-fluid bg-secondary gb-gradient'>
                        <div className='btn-group btn-group-sm'>
                            <div className='row row-cols-1 row-cols-md-1 g-1'>
                                <div className='col'>
                                    <div className="input-group input-group-sm my-auto " >
                                        <span className="input-group-text bg-secondary bg-gradient text-light border-secondary" >Regional</span>
                                        <select className=" form-select text-center" value={regional} onChange={(e) => { setRegional(e.target.value); setActualizar(!actualizar) }}>
                                            <option value='990'>CBBA</option>
                                            <option value='991'>SCRZ</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <button className='btn btn-sm btn-light mx-1' onClick={() => setActualizar(!actualizar)}>
                                <i className="fa-solid fa-rotate-right fa-spin"></i> Actualizar
                            </button>
                        </div>
                    </div>
                    <div className='table-responsive'>
                        <table className="table table-sm table-striped table-dark" >
                            <thead className='bg-gradient text-light fs-bold'>
                                <tr>
                                    <th scope="col">{`Modulos de ${regional === '990' ? 'CBBA' : 'SCRZ'}`}</th>
                                    <th scope="col">Versión</th>
                                    <th scope="col">NOVEDADES</th>
                                    <th scope="col "></th>
                                </tr>
                            </thead>
                            <tbody>
                                {modulos.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <th scope="row" className="col-3">{item.MODULO}</th>
                                            <td className='col-1 text-center'>{item.VERSION}</td>
                                            <td>{UtilsBufer.getText(item.NOVEDADES)}</td>
                                            <td className='col-2 text-end'>
                                                <button className='btn btn-sm text-light btn-secondary' onClick={() => entrarModulo(item)}>
                                                    <i className="fa-solid fa-gear fa-fade"></i> Entrar
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>}
            {vista === 1 &&
                <div>
                    <div className='container-fluid bg-dark bg-gradient'>
                        <div className='row row-cols gx-1'>
                            <div className='col my-auto' style={{minWidth:'250px',maxWidth:'250px'}}>
                                <div className='text-light fw-bold'>Modulo: {moduloSelec.MODULO}</div>
                                <div className='text-light fw-bold'>Version: {moduloSelec.VERSION}</div>
                            </div>
                            <div className="col" style={{minWidth:'250px',maxWidth:'250px'}}>
                                <div className="small fw-light text-white">Buscar Colaborador</div>
                                <div className="input-group input-group-sm">
                                    <input className="form-control border-end-0 border rounded-pill form-control-sm"
                                        type="text"
                                        id="example-search-input"
                                        onChange={() => buscarColaborador()} />
                                    <span className="input-group-append">
                                        <a className="btn btn-outline-ligth bg-secondary border-bottom-0 border rounded-pill ms-n5" type="button">
                                            <i className="fa fa-search"></i>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            <div className='col my-auto text-center' style={{minWidth:'100px',maxWidth:'100px'}}>
                                <a className='btn btn-success btn-sm' onClick={agregarPermisoColaborador}>
                                    <i className="fa-solid fa-circle-plus fa-xl"></i> Agregar
                                </a>
                            </div>
                            <div className='col my-auto text-center' style={{minWidth:'90px',maxWidth:'90px'}}>
                                <a className='btn btn-danger w-100 btn-sm' onClick={() => setVista(0)}>
                                    <i className="fa-solid fa-circle-xmark fa-xl"></i> Salir
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='table-responsive py-1' style={{height:'88vh'}}>
                        <table className="table table-striped table-bordered table-sm table-hover table-dark" id="tablaColaboradores">
                            <thead className='bg-gradient text-center fw-bold text-light'>
                                <tr>
                                    <th scope="col">EMPLEADO</th>
                                    <th scope="col">DEPARTAMENTO</th>
                                    <th scope="col">SUCURSAL</th>
                                    <th scope="col">#PERMISOS</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {empleadosModulo.map((item, index) => {
                                    return (
                                        <tr key={item.ID_EMPLEADO} className="my-auto">
                                            <td className='col-4' id="pruebaBB">
                                                <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                                    {UtilsBufer.getFotoCard(item.FOTO, 40)}
                                                    <div className='ps-2 my-auto d-none d-sm-inline'>
                                                        <div className="cargoHeader fw-bold" id="nameBuscar">{item.NOMBREX}</div>
                                                        <div className='cargoHeader '>{item.CARGO}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className='col-4'>{item.DEPARTAMENTO}</td>
                                            <td className='col-2'>{item.SUCURSAL}</td>
                                            <td className='col-1 text-center'>{item.PERMISO.split(':').length}</td>
                                            <td className='text-center'>
                                                <a className='btn btn-transparent fs-4 m-0 p-0 text-success px-2' onClick={() => agregarPermiso(item)}>
                                                    <i className="fa-solid fa-file-pen"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            <Modal show={modalAddPermiso} onHide={() => setModalAddPermiso(false)}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    {!nuevoUsuario && <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                        <div className='fa-fade'>{UtilsBufer.getFotoCard(selectEmpleado.FOTO, 40)}</div>
                        <div className='ps-2 my-auto d-none d-sm-inline'>
                            <div className="cargoHeader fw-bold text-light">{selectEmpleado.NOMBREX}</div>
                            <div className='cargoHeader text-light'>{selectEmpleado.CARGO}</div>
                        </div>
                    </div>}
                    {nuevoUsuario && <div className='text-light fw-bold text center'>Agregar Colaborador</div>}
                </Modal.Header>
                <Modal.Body>
                    <div className='container-fluid'>
                        {nuevoUsuario && <div className='container-fluid mb-2'>
                            <div className='row row-cols-2 g-2'>
                                <div className='col-4 my-auto' >
                                    <button className='btn btn-sm w-100 btn-secondary bg-gradient' onClick={() => { setModalAddColaborador(true); setModalAddPermiso(false) }}>
                                        Elegir Empleado <i className="fa-solid fa-magnifying-glass fa-xl"></i>
                                    </button>
                                </div>
                                <div className='col-8 my-auto'>
                                    {error.error === undefined && <div className="card bg-transparent flex-row m-0 p-0" style={{ border: 'none' }}>
                                        <div className='fa-fade'>{UtilsBufer.getFotoCard(selectEmpleado.FOTO, 40)}</div>
                                        <div className='ps-2 my-auto d-none d-sm-inline'>
                                            <div className="cargoHeader fw-bold text-light">{selectEmpleado.NOMBREX}</div>
                                            <div className='cargoHeader text-light'>{selectEmpleado.CARGO}</div>
                                        </div>
                                    </div>}
                                    {error.error &&
                                        <div className="alert alert-danger m-0 p-0">
                                            {error.error}
                                        </div>}
                                </div>
                            </div>
                        </div>}
                        <div className='row row-cols-1 row-cols-md-3 g-0' >
                            <div className='col col-sm-5'>
                                <input className="form-control form-control-sm border-end-0 border rounded-pill"
                                    placeholder='Buscar Permiso'
                                    type="text"
                                    id="buscarPermisoMo"
                                    onChange={() => buscarPermisos()} />
                            </div>
                        </div>
                        <div className='row row-cols-1 row-cols-md-3 g-0' >
                            <div className='col col-sm-5'>
                                <div className='text-light fw-bold text-center'><i className="fa-solid fa-tent-arrow-down-to-line"></i></div>
                                <div className='overflow-auto' style={{ height: "290px" }}>
                                    <ul className="list-group list-group-flush" id='listaPermisos'>
                                        {listaPermisos.map((item, index) => {
                                            if (permisosUsuario.indexOf(item) < 0) {
                                                return (
                                                    <li className={`list-group-item m-0 p-0 ${addPermiso === item.ID_PERMISO ? 'itemMenuOk' : 'bg-secondary'} bg-gradient`} key={index}>
                                                        <button className='w-100 btn btn-sm text-light fw-bold' onClick={() => agregarPermisoAdd(item)}>
                                                            {item.DESCRIPCION}
                                                        </button>
                                                    </li>
                                                )
                                            }
                                        })}
                                    </ul>
                                </div>
                            </div>
                            <div className='col col-sm-2 my-auto'>
                                <div className='container-fluid m-0 p-0 '>
                                    <div className='row row-cols-1'>
                                        <button className='btn btn-sm text-light' disabled={desabledAdd} onClick={() => addRmPermiso('ADD')}>
                                            <i className="fa-solid fa-circle-arrow-right fa-2xl"></i>
                                        </button>
                                        <button className='btn btn-sm text-light' disabled={desabledRemove} onClick={() => addRmPermiso('REM')}>
                                            <i className="fa-solid fa-circle-arrow-left fa-2xl"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='col col-sm-5'>
                                <div className='text-light fw-bold text-center'>Permisos Del Usuario</div>
                                <div className='overflow-auto' style={{ height: "290px" }}>
                                    <ul className="list-group list-group-flush">
                                        {permisosUsuario.map((item, index) => {
                                            return (
                                                <li className={`list-group-item m-0 p-0 ${removePermiso === item.ID_PERMISO ? 'itemMenuOk' : 'bg-secondary'} bg-gradient`} key={index}>
                                                    <button className='w-100 btn btn-sm text-light fw-bold' onClick={() => removePermisoRm(item)}>
                                                        {item.DESCRIPCION}
                                                    </button>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={modalAddColaborador} onHide={salirBusqueda}
                size="xl"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <div className='text-light fw-bold'>Buscar Colaborador</div>
                </Modal.Header>
                <Modal.Body>
                    <BuscarEmpleado setShowModal1={salirBusqueda} setColaborador={seleccionarColaborador} reg={regional} />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ModuloAcceso
